<script>
  export let href;
</script>

{#if href}
  <a class="external-link" {href} rel="noopener noreferrer" target="_blank"
    ><slot /></a
  >
{:else}
  <span>
    <slot />
  </span>
{/if}

<style>
  .external-link {
    color: #555;
    border-bottom: 1px dotted;
  }

  .external-link:hover {
    color: inherit;
  }
</style>
